import api from './api';
import { TipoArea, CreateTipoAreaForm, UpdateTipoAreaForm, Tarea, TareaSimple, CreateTareaTipoAreaDto, UpdateTareaTipoAreaConfigDto } from '../types';

export const tipoAreaService = {
  // Obtener todos los tipos de área
  async getAll(): Promise<TipoArea[]> {
    const { data } = await api.get('/TipoAreas');
    return data;
  },

  // Obtener tipos de área activos
  async getActivos(): Promise<TipoArea[]> {
    const { data } = await api.get('/TipoAreas/activos');
    return data;
  },


  // Crear nuevo tipo de área
  async create(tipoArea: CreateTipoAreaForm): Promise<TipoArea> {
    const { data } = await api.post('/TipoAreas', tipoArea);
    return data;
  },

  // Actualizar tipo de área
  async update(id: number, tipoArea: UpdateTipoAreaForm): Promise<TipoArea> {
    const { data } = await api.put(`/TipoAreas/${id}`, tipoArea);
    return data;
  },

  // Eliminar tipo de área
  async delete(id: number): Promise<void> {
    await api.delete(`/TipoAreas/${id}`);
  },

  // Obtener tareas asociadas a un tipo de área (endpoint real de backend)
  async getTareasTipoArea(tipoAreaId: number): Promise<TareaSimple[]> {
    const { data } = await api.get(`/Tareas/tipoarea/${tipoAreaId}`);
    return data;
  },

  // Agregar tarea a un tipo de área (según contrato actual)
  async addTareaATipo(tipoAreaId: number, payload: CreateTareaTipoAreaDto): Promise<Tarea> {
    const { data } = await api.post(`/TipoAreas/${tipoAreaId}/tareas`, payload);
    return data;
  },

  // Remover tarea de un tipo de área
  async removeTareaDeTipo(tipoAreaId: number, tareaId: number): Promise<void> {
    await api.delete(`/TipoAreas/${tipoAreaId}/tareas/${tareaId}`);
  },

  // Actualizar configuración de tarea en tipo de área (no soportado por backend actual; mantener firma por compatibilidad)
  async updateTareaTipoAreaConfig(_tipoAreaId: number, _tareaId: number, _payload: UpdateTareaTipoAreaConfigDto): Promise<Tarea> {
    throw new Error('Actualizar configuración de tarea por Tipo de Área no está disponible en el API actual');
  },
}; 